import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { throttle, debounce } from 'underscore';
import App from 'resizement/scripts/resize';
import Handlebars from "handlebars";





Snappy.Component.SessionHero= class SessionHero extends Snappy.BaseComponent {
    static get tagName() {
        return 'session-hero';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.renderTimeline();
        this.onResize();
        this.detectActiveSection();

    }

    setVars() {
        this.$document = $(document);
        this.$timeline = this.$element.find('.js-timeline');
        this.$timelineList = this.$timeline.find('.js-timeline-list');

        this.$scrollContainer = this.$timeline.find('.js-scroll-container');
        this.$scrollModel = this.$element.find('.js-scroll-model');
        this.$arrowLeft = this.$timeline.find('.js-arrow-left');
        this.$arrowRight = this.$timeline.find('.js-arrow-right');
        this.$arrows = this.$arrowLeft.add(this.$arrowRight);
        this.$sectionHeaders = this.$document.find('.js-session-section');
        this.timelineJson = [];
        this.headerIdPrefix = 'session-header-';
        this.timelineScrollStep = this.getTimelineScrollStep();

    }

    setEventListeners() {

        this.$arrowLeft.on('click', this.moveTimeline.bind(this, -1, this.timelineScrollStep));
        this.$arrowRight.on('click', this.moveTimeline.bind(this, 1, this.timelineScrollStep));
        this.$window.on(
            'resize:finished',
            (this.bindedResize = this.onResize.bind(this))
        );

        this.$document.on('scroll', throttle(this.detectActiveSection.bind(this), 800));
        this.$scrollContainer.on('scroll', debounce(this.onTimelineScrollFinished.bind(this), 200));
        this.headerNumber = 1;
    }

    renderTimeline() {
        const templateSource = $('#session-timeline-template').html();
        const templateFunc = Handlebars.compile(templateSource);
        this.prepareHeaders();
        const timelineHtml = templateFunc(this.timelineJson);
        this.$timelineList.append(timelineHtml);
        this.$timelineItems = this.$timelineList.find('.js-timeline-item');
    }

    prepareHeaders() {
        this.$sectionHeaders.each((i, item) => {
            const $item = $(item);
            const $dummyAnchor = $item.find('.js-session-section-anchor');
            $dummyAnchor.attr('id', this.headerIdPrefix + i);
            const headerObj = {
                isNumeric: $item.hasClass('is-numeric'),
                title: $item.data('title'),
                id: this.headerIdPrefix + i
            };


            if (headerObj.isNumeric) {
                headerObj.number = this.headerNumber;
                this.headerNumber++;
                const numberContainer = $item.find('.js-session-number');
                numberContainer.text(`${headerObj.number}. `);
            }
            this.timelineJson.push(headerObj);
        });
    }


    calculateHeadersOffset() {
        this.$sectionHeaders.each((i, item)=> {
            const $item = $(item);
            this.timelineJson[i].offsetTop = $item.offset().top;
        })
    }

    detectActiveSection() {

        const scrollPos = this.$window.scrollTop();
        let lastOverscrollItemIndex = -1;

        this.timelineJson.forEach((item, i)=> {
            if (item.offsetTop < scrollPos + 180) {
                lastOverscrollItemIndex = i;
            }
        });

        let activeItemIndex = this.timelineJson.length - 1 === lastOverscrollItemIndex ||
            (this.timelineJson[lastOverscrollItemIndex+1] && this.timelineJson[lastOverscrollItemIndex+1].offsetTop > scrollPos + App.height*0.4)
            ? lastOverscrollItemIndex
            : lastOverscrollItemIndex +1;

        if (activeItemIndex < 0) {
            activeItemIndex = 0;
        }
        if (this.activeItemIndex !== activeItemIndex) {
            this.activeItemIndex = activeItemIndex;
            this.$timelineItems.removeClass('is-active');
            this.$timelineItems.eq(activeItemIndex).addClass('is-active');
            this.scrollTimelineToView(activeItemIndex);
        }

    }

    scrollTimelineToView(activeItemIndex) {
        const padding = 25;
        const rect = this.$timelineItems.eq(activeItemIndex)[0].getBoundingClientRect();
        const leftSpace = rect.left;
        const rightSpace = App.width - rect.right - padding;
        if (leftSpace < 0) {
            this.moveTimeline(-1, Math.abs(leftSpace) + padding)
        } else if (rightSpace < 0) {
            this.moveTimeline(1, Math.abs(rightSpace) + padding)
        }
    }


    moveTimeline(direction, val) {
        const initialPos = this.$scrollContainer.scrollLeft();

        const newPos = initialPos + val*direction;
        this.$scrollContainer.animate({ scrollLeft: newPos }, {
            duration: 200,
        });



    }

    checkExtremePoints() {
        const scrollWidth =  this.$scrollContainer[0].scrollWidth;
        const scrollLeft = this.$scrollContainer.scrollLeft();
        const width = this.$scrollContainer.width();

        if (scrollWidth > width) {
            this.$arrowLeft.removeAttr('disabled');
            this.$arrowRight.removeAttr('disabled');
        }

        if (scrollLeft === 0) {
            this.$arrowLeft.attr('disabled', 'disabled');
        }
        if (scrollLeft + width ===  scrollWidth) {
            this.$arrowRight.attr('disabled', 'disabled');
        }


    }

    onTimelineScrollFinished() {
        this.checkExtremePoints();
    }

    updateDimensions() {
        this.timelineScrollStep = this.getTimelineScrollStep();
        if (App.isDesktop) {
            const containerLeft = this.$scrollModel[0].getBoundingClientRect().left;
            this.$timelineList.css('padding-left', containerLeft + 'px');
        }
    }

    getTimelineScrollStep() {
        return  (App.isDesktop) ? 360 :180;
    }

    onResize() {
        this.updateDimensions();
        this.checkExtremePoints();
        this.calculateHeadersOffset();
    }


};



// WEBPACK FOOTER //
// ./components/session-hero/scripts/session-hero.js